import AuthService from '@/services/auth'
import jwt_decode from 'jwt-decode'
import router from '@/router'

const authService = new AuthService()

export default {
    namespaced: true,
    state: {
        token: '',
        refreshToken: '',
        error: false,
        errorCode: ''
    },
    mutations: {
        setToken(state, payload) {
            state.token = payload.token
            state.refreshToken = payload.refreshToken
            state.error = false
        },
        logout(state) {
            state.token = ''
            state.refreshToken = ''
            state.error = false
        },
        authError(state, payload) {
            state.token = ''
            state.refreshToken = ''
            state.error = payload.error
            state.errorCode = payload.errorCode
        }
    },
    actions: {
        async signIn({ commit }, user) {
            try {
                commit('setLoading', true, { root: true })
                const tokenResponse = await authService.getToken(user)
                commit('auth/setToken', { 'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token }, { root: true })
            } catch(e) {
                console.log(e)
                commit('auth/authError', { 'error': true, 'errorCode': e.status }, { root: true })
            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async signInGoogle({ commit }, user) {
            try {
                commit('setLoading', true, { root: true })
                const tokenResponse = await authService.getTokenGoogle(user)
                commit('auth/setToken', { 'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token }, { root: true })
            } catch(e) {
                console.log(e)
                commit('auth/authError', { 'error': true, 'errorCode': e.status }, { root: true })
            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async signOut({commit, state}) {
            try {
                commit('setLoading', true, { root: true })
                await authService.setTokenExpired(state.token, state.refreshToken)
                commit('auth/logout', null, { root: true })
            } catch(e) {
                console.log(e)
            } finally {
                commit('setLoading', false, { root: true })
            }
        },
        async refreshToken({ commit, state }) {
            try {
                const tokenResponse = await authService.refreshToken(state.token, state.refreshToken)
                commit('auth/setToken', { 'token': tokenResponse.token, 'refreshToken': tokenResponse.refresh_token }, { root: true })
            } catch(e) {
                console.log(e)
                commit('auth/logout', null, { root: true })
                router.push({ path: `/login` })
            }
        }
    },
    getters: {
        getCurrentUser: state => state.token ? jwt_decode(state.token) : null,
        getStateToken: state => state.token
    }
}